import React from 'react'
import { UiSlider } from "../../../../_uiComponents/common/UiSlider";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../../../_uiComponents/common/UiSliderArrows";
import {
    UiColTitleWr,
    UiColTitle,
    UiViewAll,
} from "../../../../_uiComponents/common/UiPageElements";
import {
    UiCol,
    UiSingleRow,
    UiRowContainer
} from "../../../../_uiComponents/grid-container/GridContainer";
import UiShopActivityCard from "../../../../_uiComponents/cards/UiShopActivityCard"
// import UiVideoCard from "../../../_uiComponents/cards/UiVideoCard"
import ActivityImg from "../../../../../styles/img/activity-img.png"
import ActivityImg2 from "../../../../../styles/img/feed-2.png"

export default function TodayTopPicks(props) {

    const UiMainSlider = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
        ],
    };

    return (
        <>
        <div className='sb-today-top-picks'>
            <UiColTitleWr>
                <UiColTitle
                    title="Today's Top Picks"
                />
            </UiColTitleWr>
            <UiSingleRow className="mb-5 sb-spend-on-experience sb-shop-top-picks">
                <UiSlider UiSliderSettings={UiMainSlider}>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiShopActivityCard 
                                    img={ActivityImg} 
                                    isFavourite={true} 
                                    title="5 Star Surprise Get-away"
                                    content="The ultimate act of romance and intrigue. Just order, pack your bags and we will take care of the rest! "/>
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiShopActivityCard 
                                    img={ActivityImg2} 
                                    isFavourite={true} 
                                    title="Pure Gym for a year"
                                    content="At PureGym you get way more than you pay for! You can enjoy flexible memberships, unlimited classes"/>
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiShopActivityCard 
                                    isFavourite={true} 
                                    title="5 Star Surprise Get-away"
                                    img={ActivityImg}
                                    content="At PureGym you get way more than you pay for! You can enjoy flexible memberships, unlimited classes"/>
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    
                </UiSlider>
            </UiSingleRow>
            </div>

        </>
    )
}
